jQuery(document).ready(function($){

	var toggleClickEvent = 'click';
	if($(window).innerWidth() < 992 && navigator.userAgent.match(/iPhone|iPad/)){
		toggleClickEvent = 'touchend';
	}

	$(window, document, 'html, body').on('resize', function(){
		if(navigator.userAgent.match(/iPhone|iPad/)){
			toggleClickEvent = 'touchend';
		}else{
			toggleClickEvent = 'click';
		}
	});

	if(location.hash !== ""){
		if(location.hash == '#home' || $(location.hash).length || $("[data-hash='" + location.hash + "']").length){
			_autoScroll(location.hash);
		}
	}

	$(document).on(toggleClickEvent, 'a[href^="#"]:not([href$="#"])', function(){
		var hash = '#' + $(this).attr("href").split("#")[1];
		if(hash == '#home' || $(hash).length || $('[data-hash="' + hash + '"]').length){
			_autoScroll(hash);
			return false;
		}
	});

	function _autoScroll(hash){
		var target_top = 0;
		var test = setInterval(function(){
			clearInterval(test);
			if(hash != "#home"){
				var targetObj;
				if($('[data-hash="' + hash + '"]').length){
					targetObj = $('[data-hash="' + hash + '"]');
				}else if($(hash).length){
					targetObj = $(hash);
				}
				//target_top = targetObj.offset().top - $("#main-header").innerHeight();
				target_top = targetObj.offset().top;
			}
			$('body,html').animate({scrollTop: target_top}, "slow");
		}, 100);
	}

    // サブメニューのアコーディオン
    $(document).on(toggleClickEvent, '.accordion-frame', function(e) {
        e.preventDefault();
        if(!$(this).parent().hasClass("on")){
            var h = $(this).next().children().innerHeight();
            $(this).next().css("height", h);
        }
        $(this).parent().toggleClass("on");
    });

});